import script from "./BrowserInstructions.vue?vue&type=script&setup=true&lang=js"
export * from "./BrowserInstructions.vue?vue&type=script&setup=true&lang=js"

import "./BrowserInstructions.vue?vue&type=style&index=0&id=bd02d0d0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd02d0d0"]])

export default __exports__